/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import HeadMeta from '../components/HeadMeta';
import Footer from '../components/Footer';
import Nav from '../components/Nav';

interface Props {
  error?: any;
  children?: React.ReactNode;
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  style?: any;
  cookies?: any;
  bodySx?: Record<string, string | number>;
}

const PageWrapper = ({
  children,
  error,
  bodySx = {},
  ...props
}: Props): React.ReactElement => {
  return (
    <>
      <HeadMeta {...props} />
      <Nav {...props} />
      <main
        sx={{
          display: 'block',
          variant: 'containers.main',
          bg: '#E5E5E5',
        }}
      >
        <div
          sx={{
            variant: 'containers.page',
            py: 3,
            position: 'relative',
          }}
        >
          {!error ? children : <h3>{error.message || error}</h3>}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PageWrapper;
